/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/** 品质首页(含老客升级)-提现金融卡片 */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { VNode } from 'vue';
import { Component, Mixins } from 'vue-property-decorator';

import { Dialog, Loading } from '@hb/coffee';
import { namespace } from 'vuex-class';

import AnimatedNumber from 'animated-number-vue';
import FinanceBusiness from '@/mixins/finance-business';
import { session } from '@/shared/utils/storage';
import store from '@/store';
import isPrerendering from '@/shared/utils/isPrerendering';
import AdvHomeCornerMark from '@/components/adv-components/adv-home-corner-mark';
import { isCallback } from '@/api/rights';
import { CallbackType, RightPackageSourceEnum } from '@/api/rights/types';
import { MembersRightsPrefix } from '@/constant';
import { useMaxQuotaAmount } from '@/shared/utils/getMaxQuota';
import platform from '@/shared/utils/platform';
import { StateType as HomeStateType } from '@/views_v2/home/types';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import URLUtils from '@/shared/utils/URLUtils';
import { MemberRouterNameEnum } from '@/shared/right-utils/routerName';
import { skNativeContainer } from '@/api/native/container';
import { listerBack } from '@/shared/utils/backListener';
import { RouterV2Enum } from '@/router/router-names';
import { HOME_ALL_VERSION_ROUTE_PATHS } from '@/router/utils';
import RepayItem from '@/views_v2/home/components/repay-item/index.vue';
import { getMajorQuotaText } from '@/pages/home/utils';
import { UserHomeSceneEnums } from '@/enums/home-type';
import { LoadingSpinnerOutline } from '@hb/coffee-icons';
// import AdvWecomBanner from '@/components/adv-components/adv-wecom-banner';
import QuotaIncrease from '../quota-increase/index';
import ApplyIncreaseQuota from '../apply-increase-quota';
import style from './index.module.scss';
import { ubtName } from './config';
import IdentityExpiresBar from '../identity-expires-bar';

const HomeStore = namespace('home');
const TempAmountStore = namespace('tempAmount');
const _isPrerendering = isPrerendering();

enum CreditEnum{
  DEFAULT = '-1',
  NO_LOAN_INIT = '1',
  HAS_NO_AMOUNT = '2'
}

@Component
export default class AppQualityFinanceCard extends Mixins(
  FinanceBusiness,
) {
  @HomeStore.State shouldAnimate!: boolean;

  @HomeStore.State aliProductStatus!: HomeStateType['aliProductStatus'];

  @HomeStore.Action $updateState!: (data: Dictionary) => void;

  @TempAmountStore.State tempTimeout!: number;

  @TempAmountStore.Getter isHasApplyingTempAmount!: boolean;

  @TempAmountStore.Action creditApplyTempAmount!: () => Promise<boolean>;


  // 权益召回
  private callbackInfo:CallbackType = {
    showPackageDetail: false,
    callBackDocument: '',
    packageId: '',
    orderPayTyp: '',
  };

  /** 企微banner数据是否加载成功并显示 */
  private hasAdvWecomBannerData = false;

  // 响应式最高额度格式化文案
  private maxQuota = useMaxQuotaAmount();

  private async created() {
    if (!_isPrerendering && platform.isEasyBike) {
      // 只在哈罗app中展示权益召回逻辑
      this.topBarInfo();
      /** 在容器化 或者 钱包tab加载的场景 需要监听页面change事件 刷新组件数据 */
      if (await skNativeContainer() || store.state.base.isHybridAppMode) {
        /** 不能自动取消 需要持续监听 */
        /** 监听app容器切换 */
        listerBack(() => {
          if (HOME_ALL_VERSION_ROUTE_PATHS.includes(this.$route.path as RouterV2Enum)) {
            if (store.state.base.isHybridAppMode && platform.isIOS
              && window.isFinanceTabShow === false) {
              return;
            }
            this.topBarInfo();
          }
        }, false);
      }
    }
  }

  private ubtConfig = ubtName[platform.code];

  // 顶部提示条显示状态
  private async topBarInfo() {
    this.callbackInfo = await isCallback();
    if (this.callbackInfo.showPackageDetail) {
      const {
        packageId, orderPayTyp, sourceId,
      } = this.callbackInfo || {};
      this.$ubtModuleExposeNew(
        'finance_qualityHomePage_rightsCallBack',
        {
          callBackType: orderPayTyp === 'speed' ? 1 : 2,
          packageId,
          sourceId,
          from: RightPackageSourceEnum.FINANCE_HOME_CALLBACK,
        },
      );
    }
  }

  /** 处理企微banner数据加载成功的情况 */
  private handleAdvWecomBannerLoad() {
    this.hasAdvWecomBannerData = true;
  }

  /** 处理企微banner数据为空的情况 */
  private handleAdvWecomBannerNoData() {
    this.hasAdvWecomBannerData = false;
  }

  private goRightDetailUrl() {
    // 查看权益详情
    const {
      capitalCode, sourceId, packageId, orderPayTyp,
    } = this.callbackInfo;

    // 权益召回埋点
    this.$ubtPageButtonNew('finance_qualityHomePage_rightsCallBack', {
      callBackType: orderPayTyp === 'speed' ? 1 : 2,
      sourceId,
      packageId,
      from: RightPackageSourceEnum.FINANCE_HOME_CALLBACK,
    });


    // if (sourceId) {
    //   rightsUrl = URLUtils.formatUrl(
    //     `${MembersRightsPrefix}${
    //       MemberRouterNameEnum.ZHENXIANG_CARD_API
    //     }.html#/${
    //       MemberRouterNameEnum.ZHENXIANG_CARD_API
    //     }`,
    //     {
    //       packageId,
    //       capitalCode,
    //       sourceId,
    //       from: RightPackageSourceEnum.FINANCE_HOME_CALLBACK,
    //     },
    //   );
    // } else {
    //   rightsUrl = URLUtils.formatUrl(
    //     `${MembersRightsPrefix}${
    //       MemberRouterNameEnum.ZHENXIANG_CARD
    //     }.html#/${
    //       MemberRouterNameEnum.ZHENXIANG_CARD
    //     }`,
    //     {
    //       packageId,
    //       capitalCode,
    //       from: RightPackageSourceEnum.FINANCE_HOME_CALLBACK,
    //     },
    //   );
    // }
    const rightsUrl = URLUtils.formatUrl(
      `${MembersRightsPrefix}${MemberRouterNameEnum.ZHENXIANG_CARD_API
      }.html#/${MemberRouterNameEnum.ZHENXIANG_CARD_API
      }`,
      {
        packageId,
        capitalCode,
        sourceId,
        from: RightPackageSourceEnum.FINANCE_HOME_CALLBACK,
      },
    );
    // 改为跳转新的webview
    jumpToNewVersion(rightsUrl, false);
  }

  private render() {
    let content = (
      <div class={[style.contentLoading, style.withSpinner]}>
        <Loading>
          <div slot="icon">
            <LoadingSpinnerOutline />
          </div>
          <span class={style.loadingSpinner}>加载中...</span>
        </Loading>
      </div>
    );

    if (this.creditData) {
      content = this.renderContent();
    }

    return (
      <div class={[
        style.financeCardNew,
        _isPrerendering && style.prerenderContent,
      ]}>
        {/* 权益召回卡片 */}
        {this.callbackInfo.showPackageDetail && (
          /* 权益召回 */
          <div class={style.gift}>
            <div class={style.giftContent}>
              <div class={style.leftCon}>
                <span class={style.leftIcon}></span>
                <span class={style.text}>{ this.callbackInfo.callBackDocument }</span>
              </div>
              <div
                class={style.rightBtn}
                onClick={this.goRightDetailUrl.bind(this)}
                >立即查看</div>
            </div>
          </div>
        )}
        {content}

        {// 挂载身份证清晰分不够弹窗 dom
        this.getUpdatedIdentityPhotoDialog()
        }
      </div>
    );
  }

  private get showAmount(): number | string {
    // 申请过 且（有额度 或者 有订单）
    if (this.creditData && (this.hasCredit || this.creditData.hasOrder)) {
      return this.creditData.creditAmount;
    }

    return this.maxQuota.value;
  }

  private get status() {
    let status = '';
    const { creditAmount, hasOrder } = this.creditData;
    switch (true) {
      default:
        status = CreditEnum.DEFAULT;
        break;
      case hasOrder && !Number(creditAmount):
        status = CreditEnum.HAS_NO_AMOUNT;
        break;
      case !hasOrder && !Number(creditAmount):
        status = CreditEnum.NO_LOAN_INIT;
    }
    return status;
  }

  /** 支付宝小程序首页状态校验 */
  private checkAliProductStatus():boolean {
    const { dialogText } = this.aliProductStatus;
    if (dialogText) {
      this.$ubtPageButton(
        'finance_credit_blocked_dialog_show',
        'status',
        this.aliProductStatus.status || '',
      );

      Dialog.alert({
        title: dialogText,
        confirmButtonText: '知道了',
        closeable: false,
      }).then(() => {
        this.$ubtPageButton(
          'finance_credit_blocked_dialog_hide',
          'status',
          this.aliProductStatus.status || '',
        );
      });

      return false;
    }
    return true;
  }

  /** 按钮点击事件（理论上无上滑功能后没有该事件点击） */
  public onClickApply(): unknown {
    if ((platform.isAlipayMini || platform.isDingTalk) && !this.creditData) {
      return false;
    }

    const { progressingTaskId } = this.creditData;

    if (platform.isAlipayMini) {
      this.checkAliProductStatus();
      return progressingTaskId
        ? this.onShowApplyCreditProgress('臻有钱_首页_领取额度_已激活')
        : this.onApplyCredit('臻有钱_首页_领取额度_未激活');
    }
    return progressingTaskId
      ? this.showApplyProgress()
      : this.onApplyCreditHandler('collectionLimit_notActive');
  }

  private get ubtCommonParams(): Dictionary {
    const { preCreditUserSource = '', normalPreCreditModel = '' } = this.creditData || {};
    const userInfo = this.businessInfoExtra?.userInfo || {};

    return {
      scene: UserHomeSceneEnums.QUALITY,
      preCreditUserSource,
      normalPreCreditModel,
      // 包含定价标签（pricingTag）、风险标签（risk24UserSource）等用户信息
      ...userInfo,
    };
  }

  private mounted() {
    /** 金融卡片-模块曝光埋点 */
    this.$ubtModuleExposeNew('finance_loan_home_financeCard', {
      ...this.ubtCommonParams,
    });
  }

  // 申请额度
  private renderTakeAmount() {
    const {
      progressingTaskId,
      stepCount,
      activationProgress,
    } = this.creditData || {};

    let buttonName = '';

    if (progressingTaskId) {
      buttonName = '查看审核进度';
    } else {
      // 只有当资料全部填写完成以及 步骤为0的情况，显示申请额度
      buttonName = activationProgress === 100 || stepCount === 0
        ? '申请额度' : '继续激活';
    }

    return (
      <div
        class={[
          style.button,
          style.orangeCreditButton,
        ]}
        onClick={this.onClickApply.bind(this)}
        >{buttonName}
        <AdvHomeCornerMark customClassName={style.homeCornerMarkNew} />
      </div>
    );
  }

  // 文案描述
  private renderDesc() {
    const { rateFloor, rateCeil } = this.businessInfoExtra?.creditInfo || {};
    return (
      <div class={style.title}>
        <span class={style.orangeDesc}>
          综合年化利率(单利){rateFloor}%-{rateCeil}%
        </span>
      </div>
    );
  }

  // 额度为0
  private renderNoCreditAmount() {
    const { creditStatus } = this.creditData;

    return (
      <div class={style.noCreditAmount}>
        <span>{creditStatus ? '额度已用光' : '额度已过期'}</span>
      </div>
    );
  }

  // 金额部分
  private renderAnimatedNumber() {
    return this.shouldAnimate ? (
      <AnimatedNumber
        duration={1200}
        value={this.showAmount}
        formatValue={this.formatCreditAmount.bind(this)}
        complete={() => this.$updateState({ shouldAnimate: false })}
      />
    ) : this.formatCreditAmount(this.showAmount);
  }

  private get amountDes() {
    return getMajorQuotaText(this.creditData);
  }

  // 卡片主内容展示区
  private renderContent() {
    const buttonList = this.renderButtonList();
    const { identityExpiresFor30 } = this.creditData || {};

    return (
      <section class={[
        style.mainContent,
        /** 权益召回卡片无阴影* */
        this.callbackInfo && this.callbackInfo.showPackageDetail && style['no-linear'],
        /** 企微广告位卡片样式 */
        this.callbackInfo && !this.callbackInfo.showPackageDetail && this.hasAdvWecomBannerData && style['wecom-banner'],
      ]}>
        <div class={[style.content, buttonList.length > 1 && style['double-btns-content'], this.callbackInfo && !this.callbackInfo.showPackageDetail && this.hasAdvWecomBannerData && style['wecom-banner-content']]}>
          <div class={style.lgbText}>
            {this.amountDes}
          </div>

          {this.status === CreditEnum.HAS_NO_AMOUNT ? this.renderNoCreditAmount() : (
            <section class={style['amount-wrapper']}>
              <div class={[style.creditAmount, style.creditOrangeAmount]}>
              {this.renderAnimatedNumber()}
            </div>
            {/* 提额调整提醒 */}
            <QuotaIncrease />
            </section>
          )}

          {this.status === CreditEnum.HAS_NO_AMOUNT ? (
            <div class={style.subTitle}>按时还款·额度恢复后可借款</div>
          ) : this.renderDesc()}

          {buttonList.length > 0
          && <div class={style.buttonGroup}>
            <div class={[style.buttonNameList,
              buttonList.length === 1 && style.buttonNameOne]}>
              {buttonList}</div>
            {buttonList.length > 0
            && <AdvHomeCornerMark customClassName={
              buttonList.length === 1
                ? style.homeCornerMarkNew : style.homeCornerMarkRight}/>}
          </div>}
          {/** 身份证有效期小于30天，提醒用户更新bar */}
          <IdentityExpiresBar
            visible={identityExpiresFor30} class={style.customIdentityExpires} />
        </div>

        {/* 只在当前未有借款订单时，显示下方申请提额卡片 */}
        {(!this.creditData.hasOrder && !this.isAutarkySucceed()) && <ApplyIncreaseQuota isNew/>}

        {/* 有在贷订单展示还款入口 */}
        {this.creditData.hasOrder
        && <div class={style['card-list-wrapper']}>
            <RepayItem/>
        </div>
        }

      </section>
    );
  }

  private renderButtonList(): VNode[] {
    let buttonList: VNode[] = [];

    if (this.creditData) {
      const {
        creditAmount, hasOrder, creditStatus,
      } = this.creditData;

      const creditButton = (
        <div
          class={[
            style.button,
            style.orangeCreditButton,
          ]}
          onClick={this.onApplyCreditLimit.bind(this)}
        >
          {this.tempTimeout && this.isHasApplyingTempAmount
            ? `提额中 ${this.tempTimeout}s`
            : '申请提额'}
        </div>
      );

      const drawButton = (
        <div
          class={[
            style.button,
            style.orangeButton,
          ]}
          onClick={this.onDraw.bind(this, '')}
        >
          去提现
        </div>
      );

      // TODO:原始renderTakeAmount逻辑，但是感觉老户升级成功这段逻辑可以去除？
      if ((!Number(creditAmount) && !creditStatus && this.isAutarkySucceed())
      || (!Number(creditAmount) && !hasOrder && !this.isAutarkySucceed())) {
        buttonList = buttonList.concat([this.renderTakeAmount()]);
        return buttonList;
      }

      // 用户可以提额，且有在借款订单，此时在金融卡片上展示授信按钮
      if ((!this.isAutarkySucceed() && hasOrder)) {
        buttonList = buttonList.concat([creditButton]);
      }

      // 申请额度、提现、继续借钱、查看进度等
      if (this.hasCredit) {
        const isCreditAmountCanDraw = Number(creditAmount) > 0;

        buttonList = buttonList.concat(
          isCreditAmountCanDraw ? [drawButton] : [],
        );
      }
    }

    return buttonList;
  }

  private formatCreditAmount(creditAmount: number | string) {
    // 如果是整数，不展示.00
    const fixedRatio = String(Number(this.showAmount)).includes('.') ? 2 : 0;

    return Number(creditAmount)
      .toFixed(fixedRatio)
      .replace(/(\d)(?=(?:\d{3})+($|\.))/g, '$1,');
  }

  // 标记用户是否从TaglessHome切换过来的
  private getCurrentPage(): string | null {
    return session.get('currentPage') || null;
  }

  // 提现
  private onDraw(moduleName?: string) {
    const ubtClickName = (this.ubtConfig && this.ubtConfig.apply) || moduleName || 'finance_qualityHomePage_draw';
    this.$ubtPageButtonNew(ubtClickName, this.ubtCommonParams);

    this.onApplyProduct();
  }

  // 申请额度
  private onApplyCreditHandler(buttonName: string) {
    if (platform.isAlipayMini) {
      const ubtClickName = ubtName[platform.code].prechoose;
      this.onApplyCredit(ubtClickName);
      return;
    }
    const ubtClickName = this.getCurrentPage() ? `finance_taglessHome_${buttonName}` : `finance_qualityHomePage_${buttonName}`;

    this.$ubtPageButtonNew(ubtClickName, this.ubtCommonParams);
    this.onApplyCredit();
  }

  /** 申请提额 */
  private async onApplyCreditLimit() {
    if (await this.creditApplyTempAmount()) {
      this.$ubtPageButtonNew('finance_qualityHomePage_checkOut', this.ubtCommonParams);
      this.onApplyCredit();
    }
  }

  // 查看额度申请审批进度
  private showApplyProgress() {
    this.onShowApplyCreditProgress(
      this.getCurrentPage()
        ? 'finance_taglessHome_progressingTaskId'
        : 'finance_qualityHomePage_progressingTaskId',
    );
  }
}
